import React from 'react';
import {z} from 'zod';

import {Crop32Outlined} from '@mui/icons-material';

import {Spacer,SpacerPropsSchema} from './Spacer';
import SpacerSidebarPanel from './SpacerSidebarPanel';

export type SpacerProps = z.infer<typeof SpacerPropsSchema>;

export default {
    label: 'Spacer',
    icon: <Crop32Outlined />,
    type: 'Spacer',
    defaultData: {
        props: { height: 16 },
    },
    SidebarPanel: SpacerSidebarPanel,
    Component: Spacer,
    schema: SpacerPropsSchema,
};